var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex align-center"
  }, [_vm.IMGS.includes(_vm.card.brand) ? _c('v-img', {
    staticClass: "mr-3",
    staticStyle: {
      "width": "24px"
    },
    attrs: {
      "aspect-ratio": 1,
      "src": ("/credit-cards/" + (_vm.card.brand) + ".png")
    }
  }) : _c('span', {
    staticClass: "mr-1"
  }, [_vm._v("card.brand")]), _vm._v(" *" + _vm._s(_vm.card.last_4) + " ")], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }